import React, { FC, useEffect, useState } from "react";
import {
  CreateActivityDefaultFormKey,
  CreateActivityGeneralFormKey,
  EditActivityValueProps,
  ProgramTemplateActivitiesRowValue,
} from "../../modelsAndSchemas/Models";
import { useGetProgramTemplateActivityById } from "../../../../api/services/programTemplate/programTemplateApis";
import { getFieldValue, isNotEmpty } from "../../../../helpers/utils";
import { CreateActivity } from "../createActivity/CreateActivity";
import { KeyValueMap } from "../../../../redux/slices/appState/models";
import { toggleToast } from "../../../../redux/slices/appState/appStateSlice";
import { useDispatch, useSelector } from "react-redux";
import { useSiteCore } from "../../../../hooks/useSiteCore";
import { UnitTypesKey } from "../../../../helpers/constants/siteCoreKeys";
import { userPreferredLanguageSelector } from "../../../../redux/slices/appState/appStateSelector";
import { getLocalizedTopicForActivity } from "../../modelsAndSchemas/utils";

interface EditActivityProps {
  handleCloseModal: () => void;
  pageId: string;
  show: boolean;
  selectedActivity: ProgramTemplateActivitiesRowValue;
  getListOfActivitiesApi: () => void;
  templateId: string;
  frameWorkId?: string;
}
export const EditActivity: FC<EditActivityProps> = ({
  selectedActivity,
  show,
  pageId,
  handleCloseModal,
  getListOfActivitiesApi,
  templateId,
  frameWorkId = "",
}) => {
  const dispatch = useDispatch();
  const userSelectedLanguage: string = useSelector(
    userPreferredLanguageSelector,
  );
  const { commonLabels } = useSiteCore();
  const [activityValues, setActivityValues] =
    useState<EditActivityValueProps>();
  const {
    data: templateActivityData,
    isFetching: isPending,
    isError: isTemplateActivityError,
  } = useGetProgramTemplateActivityById(selectedActivity.id);

  useEffect(() => {
    if (isTemplateActivityError) {
      dispatch(
        toggleToast({
          open: true,
          message: commonLabels.someThingWentWrongPleaseTryAgainLater,
          type: "error",
        }),
      );
    }
  }, [isTemplateActivityError]);

  useEffect(() => {
    if (isNotEmpty(templateActivityData)) {
      const defaultValues = {
        [CreateActivityGeneralFormKey.candidateStatus]:
          templateActivityData?.candidateStatus ?? [],
        [CreateActivityGeneralFormKey.activityType]: getFieldValue(
          templateActivityData?.activityType,
        ),
        [CreateActivityGeneralFormKey.activityClass]: getFieldValue(
          templateActivityData?.activityClass,
        ),
        [CreateActivityGeneralFormKey.modality]:
          templateActivityData?.modality ?? [],

        [CreateActivityGeneralFormKey.topic]: getLocalizedTopicForActivity(
          templateActivityData,
          userSelectedLanguage,
        ),
        [CreateActivityGeneralFormKey.deliverables]:
          templateActivityData?.deliverables?.map(
            (item: KeyValueMap) => item.id,
          ),
        [CreateActivityGeneralFormKey.activityStatus]: getFieldValue(
          templateActivityData?.activityStatus,
        ),
        [CreateActivityGeneralFormKey.triggerBilling]:
          templateActivityData?.triggerBilling ?? false,
        [CreateActivityGeneralFormKey.lastContactDate]:
          templateActivityData?.countsTowardsLastContactDate ?? false,
        [CreateActivityGeneralFormKey.triggerTouch]:
          templateActivityData?.triggerTouchPointSurvey ?? false,
        [CreateActivityDefaultFormKey.units]: getFieldValue(
          templateActivityData.units,
        ),
        [CreateActivityDefaultFormKey.measurementMinute]:
          templateActivityData?.units === UnitTypesKey.Minutes
            ? templateActivityData.measurement
            : "",
        [CreateActivityDefaultFormKey.measurementOther]:
          templateActivityData?.units === UnitTypesKey.Days ||
          templateActivityData?.units === UnitTypesKey.Count
            ? templateActivityData.measurement
            : undefined,
        [CreateActivityDefaultFormKey.country]: "",
        [CreateActivityDefaultFormKey.countryMeasurementMinute]: "",
        [CreateActivityDefaultFormKey.countryMeasurementOther]:
          templateActivityData?.countryMeasurementOther ?? undefined,
        defaultValueExceptions:
          templateActivityData?.defaultValueExceptions ?? [],
        activityName: getFieldValue(templateActivityData?.activityName),
      };
      setActivityValues(defaultValues);
    }
  }, [templateActivityData]);

  return (
    <CreateActivity
      show={show}
      handleCloseModal={handleCloseModal}
      pageId={pageId}
      programTemplateId={templateId}
      getListOfActivitiesApi={getListOfActivitiesApi}
      isEditActivity={true}
      editActivityData={activityValues}
      isPendingActivity={isPending}
      selectedActivity={selectedActivity}
      frameWorkId={frameWorkId}
    />
  );
};
